module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-regular-68889c246da2739681c1065d15a1ab0b.eot";